var React = require('react');

function Facebook (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Facebook","transform":"matrix(0.724306,0,0,0.724306,0,0)"},React.createElement("g",{"transform":"matrix(1.38063,0,0,1.38063,73.0231,62.1805)","className":"inner_g2"},React.createElement("path",{"d":"M0,2.38L-6.745,2.38L-6.745,24.085L-16.744,24.085L-16.744,2.38L-21.499,2.38L-21.499,-6.117L-16.744,-6.117L-16.744,-11.616C-16.744,-15.547 -14.876,-21.705 -6.656,-21.705L0.75,-21.673L0.75,-13.426L-4.624,-13.426C-5.505,-13.426 -6.745,-12.985 -6.745,-11.11L-6.745,-6.109L0.873,-6.109L0,2.38Z","style":{"fillRule":"nonzero"}}))));
}

Facebook.defaultProps = {"width":"100%","height":"100%","viewBox":"0 0 91 91","version":"1.1","style":{"fillRule":"evenodd","clipRule":"evenodd","strokeMiterlimit":"10"}};

module.exports = Facebook;

Facebook.default = Facebook;
